import React from 'react';
import { FadeIn } from './FadeIn';
export const WhatYouGet = () => {
  const modules = [{
    num: '01',
    title: 'Materiales y Proveedores',
    desc: 'Conocé exactamente qué comprar, dónde conseguirlo al mejor precio y cómo no desperdiciar dinero en insumos innecesarios.',
    img: 'https://images.unsplash.com/photo-1608555855762-2b657eb1c348?auto=format&fit=crop&q=80'
  }, {
    num: '02',
    title: 'Creación de Velas Aesthetic',
    desc: 'El paso a paso práctico para crear velas perfectas, sin hundimientos, con aromas duraderos y acabados premium.',
    img: 'https://images.unsplash.com/photo-1572889813687-142272828b19?auto=format&fit=crop&q=80'
  }, {
    num: '03',
    title: 'Estrategia de Ventas',
    desc: 'Cómo dejar de depender de familiares y amigos para empezar a venderle a clientes reales que valoren tu trabajo.',
    img: 'https://images.unsplash.com/photo-1556742049-0cfed4f6a45d?auto=format&fit=crop&q=80'
  }, {
    num: '04',
    title: 'Instagram Magnético',
    desc: 'Transformá tu perfil en una tienda irresistible. Fotos, reels y copys que venden sin sonar desesperada.',
    img: 'https://images.unsplash.com/photo-1611162616305-c69b3fa7fbe0?auto=format&fit=crop&q=80'
  }, {
    num: '05',
    title: 'Precios y Ganancias',
    desc: 'La fórmula exacta para calcular tus costos y poner un precio que te deje ganancia real por cada vela vendida.',
    img: 'https://images.unsplash.com/photo-1554224155-8d04cb21cd6c?auto=format&fit=crop&q=80'
  }];
  return <section className="py-24 bg-white" data-id="element-208">
      <div className="max-w-4xl mx-auto px-6" data-id="element-209">
        <FadeIn className="text-center mb-16" data-id="element-210">
          <h2 className="text-4xl md:text-5xl mb-4" data-id="element-211">Qué incluye el programa</h2>
          <p className="text-xl text-text-brown/70" data-id="element-212">
            Un sistema completo diseñado para que empieces desde cero.
          </p>
        </FadeIn>

        <div className="space-y-8" data-id="element-213">
          {modules.map((mod, i) => <FadeIn key={i} delay={i * 0.1} direction="up" data-id="element-214">
              <div className="flex flex-col md:flex-row gap-6 bg-cream rounded-3xl p-6 border border-nude hover:shadow-soft transition-shadow" data-id="element-215">
                <div className="w-full md:w-1/3 aspect-video md:aspect-square rounded-2xl overflow-hidden shrink-0" data-id="element-216">
                  <img src={mod.img} alt={mod.title} className="w-full h-full object-cover" data-id="element-217" />
                </div>
                <div className="flex flex-col justify-center" data-id="element-218">
                  <span className="text-accent-rose-deep font-serif text-5xl opacity-50 mb-2" data-id="element-219">
                    {mod.num}
                  </span>
                  <h3 className="text-2xl font-bold mb-3" data-id="element-220">{mod.title}</h3>
                  <p className="text-text-brown/80 leading-relaxed" data-id="element-221">
                    {mod.desc}
                  </p>
                </div>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
};